export function ScheduleGrid() {
  return (
    <div className="space-y-4">
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
        <div className="flex flex-col items-center justify-center py-12 gap-3">
          <span className="text-5xl">📅</span>
          <p className="text-slate-300 font-medium text-sm">Coming soon</p>
          <p className="text-slate-500 text-xs text-center max-w-xs">
            AI-recommended ad scheduling and dayparting will be available once sufficient campaign data is collected.
          </p>
        </div>
      </div>
    </div>
  );
}
